<template>
  <div class="tableTransaction">
    <div
      class="tableTransaction__header"
      :class="{ 'tableTransaction__header--light': hasGeneralHeader }"
    >
      <slot :id="tx.txid" :time="tx.time" name="header" />
    </div>
    <div class="tableTransaction__row">
      <div class="tableTransaction__cell">
        <slot :inputs="tx.inputs" name="input" />
      </div>
      <div class="tableTransaction__cell tableTransaction__cell--icon">
        <gl-transaction-icon :type="tx.type" />
      </div>
      <div class="tableTransaction__cell">
        <slot
          :outputs="tx.outputs"
          :type="tx.type"
          :minted="tx?.minting?.mintedAmount"
          name="output"
        />
      </div>
    </div>
    <div v-if="$slots.confirmation" class="tableTransaction__confirmation">
      <slot :confirmations="tx.confirmations" name="confirmation" />
    </div>
  </div>
</template>

<script>
import GlTransactionIcon from './GlTransactionIcon'

export default {
  name: 'GlTransaction',
  components: { GlTransactionIcon },
  props: {
    hasGeneralHeader: {
      type: Boolean,
      default: false,
    },
    tx: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTransaction {
  color: #fff;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;

  &__header {
    @include text-truncate;

    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.38);
    font-size: 13px;
    line-height: 20px;
    padding: 10px 16px;

    &--light {
      background: rgba(255, 255, 255, 0.07);
    }
  }

  &__row {
    padding: 8px 8px 0;

    @media (min-width: $breakpoint-lg) {
      display: flex;
    }
  }

  &__cell {
    overflow: hidden;
    padding: 8px;

    @media (min-width: $breakpoint-lg) {
      flex: 1;
      padding-bottom: 0;
    }

    &--icon {
      text-align: center;

      @media (min-width: $breakpoint-lg) {
        flex: 0 0 auto;
      }

      @media (min-width: $breakpoint-xl) {
        padding-left: 86px;
        padding-right: 86px;
      }
    }
  }

  &__confirmation {
    display: flex;
    flex-direction: column;
    margin-top: 16px;

    @media (min-width: $breakpoint-md) {
      flex-direction: row;
      justify-content: flex-end;
    }
  }
}
</style>
